<template>
  <div
    :class="[{ 'rate-details': true }, { 'custom-scroll': true }]"
    style="overflow: scroll"
  >
    <div class="rate-details__header">
      <h4>
        Rates
      </h4>
      <md-button :disabled="saving" class="md-primary" @click="save()">
        <md-icon>
          save
        </md-icon>
      </md-button>
    </div>
    <md-progress-bar v-if="saving" md-mode="indeterminate"></md-progress-bar>

    <md-field>
      <label> Name </label>
      <md-input v-model="rate.name"></md-input>
    </md-field>
    <md-table>
      <md-table-row>
        <md-table-head>Hours</md-table-head>
        <md-table-head>Fee</md-table-head>
        <md-table-head class="text-right">
          <span style="text-align:right;">
            Actions
          </span>
        </md-table-head>
      </md-table-row>
      <md-table-row
        v-for="(item, index) of rate.rates"
        slot="md-table-row"
        :key="index"
      >
        <md-table-cell md-label="Hours">
          <span v-if="editing != index"> {{ item.hours }} </span>
          <md-field v-if="editing == index">
            <md-input v-model="item.hours" type="number">
              <!-- 
              type='numbe'r
              v-model.number="item.hours"
            -->
            </md-input>
          </md-field>
        </md-table-cell>
        <md-table-cell md-label="Fee" md-sort-by="name">
          <span v-if="editing != index"> {{ item.cost }} </span>
          <md-field v-if="editing == index">
            <md-input v-model="item.cost" type="number"> </md-input>
          </md-field>
        </md-table-cell>
        <md-table-cell md-label="Actios">
          <md-button
            v-if="editing == null"
            class="md-icon-button md-primary"
            @click="editing = index"
          >
            <md-icon>
              edit
            </md-icon>
          </md-button>
          <md-button
            v-if="editing == null"
            class="md-icon-button md-danger"
            @click="remove(index)"
          >
            <md-icon>
              delete
            </md-icon>
          </md-button>
          <md-button
            v-if="editing == index"
            class="md-icon-button md-danger"
            @click="editing = null"
          >
            <md-icon>
              close
            </md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div class="md-layout md-alignment-center-right">
      <md-button class="md-just-icon md-primary" @click="addNew()">
        <md-icon>
          add
        </md-icon>
      </md-button>
    </div>
  </div>
</template>
<script>
import Rates from '@/api/rates'
export default {
  name: 'RateDetails',
  props: {
    rate: {
      type: Object,
      default: () => {
        return {
          name: '',
          rates: []
        }
      },
      required: false
    },
    action: {
      type: String,
      default: () => {
        return 'none'
      },
      required: false
    }
  },
  data() {
    return {
      saving: false,
      editing: null,
      rateManage: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.action === 'edit') {
      Rates.get(this.rate.id)
        .then(response => {
          if (response.status === 200) {
            if (response.data.response) {
              this.$emit('updateProps', {
                target: 'rate',
                data: response.data.rate
              })
            }
          }
        })
        .catch(error => {
          console.error(error.response)
          this.showMessage({
            text: 'Something went wrong when trying to get the rate.',
            type: 'danger'
          })
        })
    }
    this.rate.rates = this.rate.rates.sort((a, b) => {
      return a.hours > b.hours ? 1 : -1
    })
  },
  methods: {
    save() {
      this.saving = true
      if (this.rate.rates.length == 0) {
        this.saving = false
        this.showMessage({
          text: 'Warning! , You must add rates',
          type: 'warning'
        })
        return
      }

      const responseValidation = this.validatedRate()
      if (!responseValidation.response) {
        this.saving = false
        this.showMessage({
          text: responseValidation.message,
          type: 'warning'
        })
        return
      }

      const method = this.rate.id
        ? Rates.update(this.rate)
        : Rates.save(this.rate)
      method
        .then(response => {
          this.showMessage({
            text: 'Changes saved successfully!',
            type: 'success'
          })
          this.saving = false
          this.$emit('saved', response.data)
        })
        .catch(e => {
          this.saving = false
          console.error(e)
          if (e.response.data) {
            if (e.response.data.message.hasOwnProperty('name')) {
              if (typeof e.response.data.message.name === 'object') {
                e.response.data.message.name.forEach((value, index, data) => {
                  this.showMessage({
                    text: value,
                    type: 'danger'
                  })
                }, this)
              }
            } else {
              this.showMessage({
                text: 'Error, rates could not be saves',
                type: 'danger'
              })
            }
          } else {
            this.showMessage({
              text: 'Error, rates could not be saves',
              type: 'danger'
            })
          }
        })
    },
    remove(index) {
      this.rate.rates.splice(index, 1)
    },
    addNew() {
      this.rate.rates.push({
        cost: null,
        hours: null
      })
      this.editing = this.rate.rates.length - 1
    },
    showMessage(message) {
      this.$notify({
        message: message.text,
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: message.type
      })
    },
    onListenerItemRate($event, currentRate, field) {
      switch (field.toString().trim()) {
        case 'hour':
          {
            if (currentRate.hours) {
              let hour = this.getNumbersInString(
                currentRate.hours.toString().trim()
              )
              currentRate.hours = hour
            }
          }
          break
        case 'cost':
          {
            if (currentRate.cost) {
              let cost = this.getNumbersInString(
                currentRate.cost.toString().trim()
              )
              currentRate.cost = cost
            }
          }
          break
        default:
          break
      }
    },
    getNumbersInString(string) {
      var tmp = string.split('')
      var map = tmp.map(function(current) {
        if (!isNaN(parseInt(current))) {
          return current
        }
      })

      var numbers = map.filter(function(value) {
        return value != undefined
      })

      return numbers.join('')
    },
    validatedRate() {
      let response = {
        response: true,
        message: 'Correct data!'
      }
      if (this.rate.name) {
        if (this.rate.name.toString().trim() === '') {
          response.response = false
          response.message = 'You need to enter the rate name'
          return response
        }
      }

      this.rate.rates.forEach((value, index, data) => {
        if (value.hours && value.cost) {
          if (
            value.hours.toString().trim() === '' ||
            value.cost.toString().trim() === ''
          ) {
            response.response = false
            response.message = 'Need to enter values for rates!'
            return response
          }
        } else {
          response.response = false
          response.message = 'Need to enter values for rates!'
          return response
        }
      }, this)

      return response
    }
  }
}
</script>
<style lang="scss" scoped>
.rate-details {
  padding: 0 1.5rem 1.5rem;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .md-table-head,
  .md-table-cell {
    &:last-child {
      text-align: right;
    }
  }
  .md-button:last-child {
    margin-left: 1rem;
  }
}
</style>
